import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectOrderStepsListOptions, selectOrderStepsListStructure } from '@/features/domain/lists'

export function useSearchedOrderStepIds() {
  const query = useSelector(selectOrderStepsListOptions).search.query
  const listStructure = useSelector(selectOrderStepsListStructure).list

  return useMemo(
    () => ({
      query,
      filteredOrderStepIds:
        // TS can't infer string[] with a simple `filter`
        listStructure.reduce<string[]>((acc, item) => {
          if (typeof item === 'string') {
            acc.push(item)
          }
          return acc
        }, []),
    }),
    [listStructure, query],
  )
}
